import imageShortcutSimpleFrameWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_simple_frame_white_fill_40.svg';
import imageShortcutPrismMatteWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_prism_matte_white_fill_40.svg';
import imageShortcutMetalFrameFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_metal_frame_fill_40.svg';
import imageShortcutRectangularProjectionFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_rectangular_projection_fill_40.svg';
import imageShortcutRoundedCornerRectangleFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_rounded_corner_rectangle_fill_40.svg';
import imageShortcutSoftEdgeRectangleFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_soft_edge_rectangle_fill_40.svg';
import imageShortcutDoubleFrameBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_double_frame_black_fill_40.svg';
import imageShortcutThickMatteBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_thick_matte_black_fill_40.svg';
import imageShortcutSimpleFrameBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_simple_frame_black_fill_40.svg';
import imageShortcutPrismEllipseBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_prism_ellipse_black_fill_40.svg';
import imageShortcutComplexFrameBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_complex_frame_black_fill_40.svg';
import imageShortcutMediumComplexFrameBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_medium_complex_frame_black_fill_40.svg';
import imageShortcutCenteredRectangleShadowFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_centered_rectangle_shadow_fill_40.svg';
import imageShortcutCircularDiagonalWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_circular_diagonal_white_fill_40.svg';
import imageShortcutClippedDiagonalWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_clipped_diagonal_white_fill_40.svg';
import imageShortcutMediumComplexFrameWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_medium_complex_frame_white_fill_40.svg';
import imageShortcutRotationWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_rotation_white_fill_40.svg';
import imageShortcutPerspectiveShadowWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_perspective_shadow_white_fill_40.svg';
import imageShortcutLoosePerspectiveWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_loose_perspective_white_fill_40.svg';
import imageShortcutSoftEdgeEllipseFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_soft_edge_ellipse_fill_40.svg';
import imageShortcutPrismRectangleFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_prism_rectangle_fill_40.svg';
import imageShortcutPrismPerspectiveFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_prism_perspective_fill_40.svg';
import imageShortcutImageRightPerspectiveFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_image_right_perspective_fill_40.svg';
import imageShortcutPrismLeftPerspectiveWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_prism_left_perspective_white_fill_40.svg';
import imageShortcutImagePrismBlackFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_image_prism_black_fill_40.svg';
import imageShortcutImagePrismWhiteFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_image_prism_white_fill_40.svg';
import imageShortcutMetalRoundedRectangleFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_metal_rounded_rectangle_fill_40.svg';
import imageShortcutMetalEllipseFill from '@tencent/docs-design-resources/icon/desktop/svg/image_shortcut_metal_ellipse_fill_40.svg';
import i18n from '@i18next/i18n';
import { IPictureModelStyle } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/picture-model-props.interface';
import { EEffectAlgn } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { ILineCap } from '@src/slide/domain/ui-model/element-modeles/property/border/border.interface';
import { LineJoin } from '@tencent/alloy-renderer';
import { CompoundType } from '@tencent/alloy-renderer-adapter';

export {
    imageShortcutSimpleFrameWhiteFill,
    imageShortcutPrismMatteWhiteFill,
    imageShortcutMetalFrameFill,
    imageShortcutRectangularProjectionFill,
    imageShortcutRoundedCornerRectangleFill,
    imageShortcutSoftEdgeRectangleFill,
    imageShortcutDoubleFrameBlackFill,
    imageShortcutThickMatteBlackFill,
    imageShortcutSimpleFrameBlackFill,
    imageShortcutPrismEllipseBlackFill,
    imageShortcutComplexFrameBlackFill,
    imageShortcutMediumComplexFrameBlackFill,
    imageShortcutCenteredRectangleShadowFill,
    imageShortcutCircularDiagonalWhiteFill,
    imageShortcutClippedDiagonalWhiteFill,
    imageShortcutMediumComplexFrameWhiteFill,
    imageShortcutRotationWhiteFill,
    imageShortcutPerspectiveShadowWhiteFill,
    imageShortcutLoosePerspectiveWhiteFill,
    imageShortcutSoftEdgeEllipseFill,
    imageShortcutPrismRectangleFill,
    imageShortcutPrismPerspectiveFill,
    imageShortcutImageRightPerspectiveFill,
    imageShortcutPrismLeftPerspectiveWhiteFill,
    imageShortcutImagePrismBlackFill,
    imageShortcutImagePrismWhiteFill,
    imageShortcutMetalRoundedRectangleFill,
    imageShortcutMetalEllipseFill,
};

export interface IPictureFastStyleConfig {
    id: number;
    title: string;
    icon: string;
    style: Partial<IPictureModelStyle>;
}

// 下面注释的样式目前还原还有问题
export const PictureFastStyleConfigs: IPictureFastStyleConfig[] = [
    // {
    //     id: 1,
    //     title: i18n.t('简单框架，白色'),
    //     icon: imageShortcutSimpleFrameWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 2,
    //     title: i18n.t('棱台亚光，白色'),
    //     icon: imageShortcutPrismMatteWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 3,
    //     title: i18n.t('金属框架'),
    //     icon: imageShortcutMetalFrameFill,
    //     style: {},
    // },
    {
        id: 4,
        title: i18n.t('矩形投影'),
        icon: imageShortcutRectangularProjectionFill,
        style: {
            border: {
                noFill: 1,
            },
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.TL,
                    blurRad: 23,
                    dir: 45,
                    dist: 11,
                    rotWithShape: 0,
                    tdColor: new TDColor({ rgbaStr: '#333333a5' }),
                    color: '#333333',
                    opacity: 35,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    {
        id: 5,
        title: i18n.t('映像圆角矩形'),
        icon: imageShortcutRoundedCornerRectangleFill,
        style: {
            bgShape: 'roundRect',
            controlValues: [0.08594],
            border: {
                noFill: 1,
            },
            fillBackground: {
                color: '#edededff',
                solidFill: {
                    color: new TDColor({ rgbaStr: '#edededff' }),
                },
            },
            effect: {
                reflection: {
                    algn: EEffectAlgn.BL,
                    blurRad: 1,
                    dir: 90,
                    dist: 0.3937,
                    startOpacity: 62,
                    size: 28,
                    sy: -1,
                    rotWithShape: 0,
                },
            },
        },
    },
    {
        id: 6,
        title: i18n.t('柔化边缘矩形'),
        icon: imageShortcutSoftEdgeRectangleFill,
        style: {
            border: {
                noFill: 1,
            },
            effect: {
                softEdge: {
                    size: 8.8582,
                },
            },
        },
    },
    {
        id: 7,
        title: i18n.t('双框架，黑色'),
        icon: imageShortcutDoubleFrameBlackFill,
        style: {
            border: {
                width: 36,
                linecap: ILineCap.Square,
                style: 'solid',
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                color: '#000000ff',
                compoundType: CompoundType.THICKTHIN,
            },
            effect: {
                shadow: {
                    isOuter: false,
                    blurRad: 6,
                    dir: 0,
                    dist: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#000000' }),
                    opacity: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    {
        id: 8,
        title: i18n.t('厚重哑光，黑色'),
        icon: imageShortcutThickMatteBlackFill,
        style: {
            border: {
                width: 70,
                linecap: ILineCap.Square,
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                color: '#000000ff',
            },
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.BL,
                    blurRad: 20,
                    dir: 45,
                    dist: 15,
                    rotWithShape: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#00000066' }),
                    opacity: 60,
                    size: 90,
                    sizeX: 100,
                    sizeY: 90,
                },
            },
            fillBackground: {
                solidFill: {
                    color: new TDColor({ rgbaStr: '#000000ff' }),
                },
                color: '#000000ff',
            },
        },
    },
    {
        id: 9,
        title: i18n.t('简单框架，黑色'),
        icon: imageShortcutSimpleFrameBlackFill,
        style: {
            border: {
                width: 6,
                linecap: ILineCap.Square,
                style: 'solid',
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                color: '#000000ff',
            },
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.TL,
                    blurRad: 4,
                    dir: 45,
                    dist: 3,
                    rotWithShape: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#0000006d' }),
                    opacity: 57,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    // {
    //     id: 10,
    //     title: i18n.t('棱台形椭圆，黑色'),
    //     icon: imageShortcutPrismEllipseBlackFill,
    //     style: {},
    // },
    {
        id: 11,
        title: i18n.t('复杂框架，黑色'),
        icon: imageShortcutComplexFrameBlackFill,
        style: {
            border: {
                width: 14,
                linecap: ILineCap.Square,
                style: 'solid',
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                color: '#000000ff',
                compoundType: CompoundType.THICKTHIN,
            },
            effect: {
                shadow: {
                    isOuter: false,
                    blurRad: 6,
                    dir: 0,
                    dist: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                    opacity: 0,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    {
        id: 12,
        title: i18n.t('中等复杂框架，黑色'),
        icon: imageShortcutMediumComplexFrameBlackFill,
        style: {
            border: {
                width: 20,
                linecap: ILineCap.Square,
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#000000ff' }),
                color: '#000000ff',
            },
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.TL,
                    blurRad: 4.5,
                    dir: 45,
                    dist: 4,
                    rotWithShape: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#00000066' }),
                    opacity: 60,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    {
        id: 13,
        title: i18n.t('居中矩形阴影'),
        icon: imageShortcutCenteredRectangleShadowFill,
        style: {
            border: {
                noFill: 1,
            },
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.TL,
                    blurRad: 15,
                    dir: 0,
                    dist: 0,
                    rotWithShape: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#000000b2' }),
                    opacity: 30,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    {
        id: 14,
        title: i18n.t('圆形对角，白色'),
        icon: imageShortcutCircularDiagonalWhiteFill,
        style: {
            bgShape: 'round2DiagRect',
            border: {
                width: 14,
                linecap: ILineCap.Square,
                linejoin: LineJoin.Miter,
                tdColor: new TDColor({ rgbaStr: '#ffffffff' }),
                color: '#ffffffff',
            },
            controlValues: [0.16667, 0],
            effect: {
                shadow: {
                    isOuter: true,
                    algn: EEffectAlgn.TL,
                    blurRad: 20,
                    dir: 0,
                    dist: 0,
                    rotWithShape: 0,
                    color: '#000000',
                    tdColor: new TDColor({ rgbaStr: '#0000006d' }),
                    opacity: 57,
                    size: 100,
                    sizeX: 100,
                    sizeY: 100,
                },
            },
        },
    },
    // {
    //     id: 15,
    //     title: i18n.t('剪裁对角线，白色'),
    //     icon: imageShortcutClippedDiagonalWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 16,
    //     title: i18n.t('中等复杂框架，白色'),
    //     icon: imageShortcutMediumComplexFrameWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 17,
    //     title: i18n.t('旋转，白色'),
    //     icon: imageShortcutRotationWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 18,
    //     title: i18n.t('透视阴影，白色'),
    //     icon: imageShortcutPerspectiveShadowWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 19,
    //     title: i18n.t('松散透视，白色'),
    //     icon: imageShortcutLoosePerspectiveWhiteFill,
    //     style: {},
    // },
    {
        id: 20,
        title: i18n.t('柔化边缘椭圆'),
        icon: imageShortcutSoftEdgeEllipseFill,
        style: {
            bgShape: 'ellipse',
            border: {
                noFill: 1,
            },
            effect: {
                softEdge: {
                    size: 8.8582,
                },
            },
        },
    },
    // {
    //     id: 21,
    //     title: i18n.t('棱台矩形'),
    //     icon: imageShortcutPrismRectangleFill,
    //     style: {},
    // },
    // {
    //     id: 22,
    //     title: i18n.t('棱台透视'),
    //     icon: imageShortcutPrismPerspectiveFill,
    //     style: {},
    // },
    // {
    //     id: 23,

    //     title: i18n.t('映像右透视'),

    //     icon: imageShortcutImageRightPerspectiveFill,

    //     style: {},
    // },
    // {
    //     id: 24,
    //     title: i18n.t('棱台左透视，白色'),
    //     icon: imageShortcutPrismLeftPerspectiveWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 25,
    //     title: i18n.t('映像棱台，黑色'),
    //     icon: imageShortcutImagePrismBlackFill,
    //     style: {},
    // },
    // {
    //     id: 26,
    //     title: i18n.t('映像棱台，白色'),
    //     icon: imageShortcutImagePrismWhiteFill,
    //     style: {},
    // },
    // {
    //     id: 27,
    //     title: i18n.t('金属圆角矩形'),
    //     icon: imageShortcutMetalRoundedRectangleFill,
    //     style: {},
    // },
    // {
    //     id: 28,
    //     title: i18n.t('金属椭圆'),
    //     icon: imageShortcutMetalEllipseFill,
    //     style: {},
    // },
];
